import { Routes } from '@angular/router';

import { authenticationGuard } from './shared/auth/services/auth.guard';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authenticationGuard()],
    children: [
      /** Dashboard */
      {
        path: '',
        loadChildren: () => import('./block-menu/block-menu.routes')
      },
      /** Home Dashboard */
      {
        path: 'home',
        loadChildren: () => import('./home/home.routes')
      },
      /** Gov Dashboard */
      {
        path: 'gov',
        loadChildren: () => import('./gov-home/gov-home.routes')
      },
      /** Installation Routes */
      {
        path: 'installations',
        loadChildren: () => import('./installations/installations.routes')
      },
      // /** Admin Routes */
      {
        path: 'admin',
        loadChildren: () => import('./admin-home/admin-home.routes')
      },
      {
        path: 'administrative',
        loadChildren: () => import('./administrative/administrative.routes')
      },
      /** Tasks Routes */
      {
        path: 'tasks',
        loadChildren: () => import('./task/task.routes')
      },
      /** Warehouse Routes */
      {
        path: 'warehouses',
        loadChildren: () => import('./warehouses/warehouses.routes')
      },
      /** Software License Routes */
      {
        path: 'software-licenses',
        loadChildren: () => import('./software-licenses/software-licenses.routes')
      },
      /** CDRLS */
      {
        path: 'cdrls',
        loadChildren: () => import('./cdrls/cdrls.routes')
      },
      /** Help Desk Support */
      {
        path: 'rtp',
        loadChildren: () => import('./rtp/rtp.routes')
      },
      /** User Management */
      {
        path: 'users',
        loadChildren: () => import('./users/user.routes')
      },
      /** Role Management */
      {
        path: 'roles',
        loadChildren: () => import('./administrative/feature/roles/roles.routes')
      },
      /** Settings Management */
      {
        path: 'settings',
        loadComponent: () => import('./settings/settings.component').then(c => c.SettingsComponent)
      },
      /** Help Desk Support */
      {
        path: 'support',
        loadChildren: () => import('./support/support.routes')
      }
    ]
  },
  /** Authentication Routes */
  {
    path: 'auth',
    loadChildren: () => import('./shared/auth/auth.routes')
  }
];
